/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestWETH extends Contract<ITestWETH> {
  allowance: Call<(_owner: AddressLike, _spender: AddressLike) => BigNumber, ITestWETH>
  'allowance(address,address)': Call<(_owner: AddressLike, _spender: AddressLike) => BigNumber, ITestWETH>
  approve: Send<(_spender: AddressLike, _amount: BigNumberish) => boolean, ITestWETH>
  'approve(address,uint256)': Send<(_spender: AddressLike, _amount: BigNumberish) => boolean, ITestWETH>
  balanceOf: Call<(_account: AddressLike) => BigNumber, ITestWETH>
  'balanceOf(address)': Call<(_account: AddressLike) => BigNumber, ITestWETH>
  decimals: Call<() => BigNumber, ITestWETH>
  'decimals()': Call<() => BigNumber, ITestWETH>
  deposit: Send<() => void, ITestWETH>
  'deposit()': Send<() => void, ITestWETH>
  symbol: Call<() => string, ITestWETH>
  'symbol()': Call<() => string, ITestWETH>
  totalSupply: Call<() => BigNumber, ITestWETH>
  'totalSupply()': Call<() => BigNumber, ITestWETH>
  transfer: Send<(_recipient: AddressLike, _amount: BigNumberish) => boolean, ITestWETH>
  'transfer(address,uint256)': Send<(_recipient: AddressLike, _amount: BigNumberish) => boolean, ITestWETH>
  transferFrom: Send<(_sender: AddressLike, _recipient: AddressLike, _amount: BigNumberish) => boolean, ITestWETH>
  'transferFrom(address,address,uint256)': Send<(_sender: AddressLike, _recipient: AddressLike, _amount: BigNumberish) => boolean, ITestWETH>
  withdraw: Send<(amount_: BigNumberish) => void, ITestWETH>
  'withdraw(uint256)': Send<(amount_: BigNumberish) => void, ITestWETH>
}

let ITestWETHBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestWETHBytecode = '0x';
}

// prettier-ignore
export const ITestWETH = contract<ITestWETH>(ITestWETHBytecode)`
  event Approval(address indexed owner, address indexed spender, uint256 value)
  event Deposit(address indexed destination, uint256 value)
  event Transfer(address indexed from, address indexed to, uint256 value)
  event Withdrawal(address indexed source, uint256 value)
  function allowance(address _owner, address _spender) view returns (uint256 amount_)
  function approve(address _spender, uint256 _amount) returns (bool success_)
  function balanceOf(address _account) view returns (uint256 balance_)
  function decimals() view returns (uint8 decimals_)
  function deposit() payable
  function symbol() view returns (string symbol_)
  function totalSupply() view returns (uint256 supply_)
  function transfer(address _recipient, uint256 _amount) returns (bool success_)
  function transferFrom(address _sender, address _recipient, uint256 _amount) returns (bool success_)
  function withdraw(uint256 amount_)
`;